export default __webpack_public_path__ + "static/media/image-002.36dc1558.png";